module.exports = __webpack_public_path__ + "static/media/back.5645b857.jpg";